/* eslint-disable react/no-danger */
import React, { useState, useRef } from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

export default function FreeZoneTwoColumnsTextContentWithVideo({ id, data }) {
  const { title, text, videoUrl, backgroundImage, backgroundImageMobile } = data;
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMouseOver, setIsMouseOver] = useState(false);
  const videoRef = useRef(null);

  const handleTogglePlayback = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
    setIsPlaying((prev) => !prev);
  };

  const handleMouseLeave = () => {
    setIsMouseOver(false);
  };

  const handleMouseEnter = () => {
    setIsMouseOver(true);
  };
  return (
    <section id={id} className="relative overflow-x-hidden">
      {isEmpty(backgroundImage) || (
        <div className="hidden md:block absolute z-5 h-full w-full lazy-load-image:!flex bg-white">
          <LazyLoadImage
            src={backgroundImage.url}
            fill
            effect="blur"
            placeholderSrc={`${backgroundImage}`}
            className="w-full min-h-[475px] md:min-h-[480px] object-cover object-right !opacity-10"
          />
        </div>
      )}
      {isEmpty(backgroundImageMobile) || (
        <div className="md:hidden absolute z-5 h-full w-full lazy-load-image:!flex bg-white">
          <LazyLoadImage
            src={backgroundImageMobile.url}
            fill
            effect="blur"
            placeholderSrc={`${backgroundImageMobile}`}
            className="w-full min-h-[456px] object-cover object-right !opacity-10"
          />
        </div>
      )}
      <Sprites
        name="freezone-corner-left-arrow"
        className="absolute rtl:-scale-x-100
        ltr:-right-4 ltr:md:-right-12 ltr:lg:-right-16 ltr:xl:-right-20 ltr:1xl:-right-11 
        ltr:2xl:right-0 
        rtl:-left-4 rtl:md:-left-12 rtl:lg:-left-16 rtl:xl:-left-20 rtl:1xl:-left-11 rtl:2xl:left-0
        w-auto top-12 md:top-28 xl:top-14 1xl:top-6 2xl:top-0 
        h-[130px] md:h-[150px] lg:h-[200px] xl:h-[300px] 1xl:h-[410px] 2xl:h-[480px]"
      />
      <BoxedContainer>
        <div
          className="flex flex-col md:flex-row gap-7 md:gap-[30px] pt-[52px] pb-[48px]
        md:py-[100px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.6 }}
            viewport={{ once: true }}
            dangerouslySetInnerHTML={{ __html: title }}
            className="text-clamp20to40 h2-child:text-clamp20to40 text-[#231F20] 
            h2-child:leading-1.2 max-w-[290px] md:w-[40%] md:max-w-[570px] h2-child:m-0
             h2-child:md:w-[90%]"
          />
          <div className="md:hidden h-[2px] w-[50px] bg-[#CE445B]" />
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.7 }}
            viewport={{ once: true }}
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-1.375 p-child:mb-0 p-child:ltr:font-URWDINRegular p-child:rtl:font-GESSTwoDWTCLight flex flex-col gap-y-4
            md:gap-y-8 md:w-[60%] md:max-w-[570px]"
          />
        </div>
      </BoxedContainer>
      {isEmpty(videoUrl) || (
        <div
          className="w-full md:h-[600px] z-10 relative"
          onMouseLeave={handleMouseLeave}
          onMouseEnter={handleMouseEnter}>
          {videoUrl.toLowerCase().includes('.mp4') ? (
            <>
              <video className="w-full h-full aspect-video object-cover" ref={videoRef}
              muted
              playsInline
              loop
              autoPlay
               >
                <source src={videoUrl} type="video/mp4" />
              </video>
              {/* <button
                type="button"
                onClick={handleTogglePlayback}
                className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-0 bg-white z-20 
                  w-[50px] h-[50px] md:w-[75px] md:h-[75px] 2l:w-[100px] 2l:h-[100px] rounded-full transition-opacity duration-300
                  ${isPlaying ? (isMouseOver ? 'opacity-100' : 'opacity-0') : ''} `}>
                {isPlaying ? (
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="50" fill="#CE445B" />
                    <path
                      d="M58.8229 34.0001H51.7658C51.5038 34.0001 51.2915 34.2124 51.2915 34.4744V65.5258C51.2915 65.7877 51.5038 66 51.7658 66H58.8229C59.0849 66 59.2971 65.7877 59.2971 65.5258V34.4744C59.2971 34.2124 59.0849 34.0001 58.8229 34.0001Z"
                      fill="white"
                    />
                    <path
                      d="M47.5314 34H40.4742C40.2123 34 40 34.2123 40 34.4742V65.5256C40 65.7876 40.2123 65.9999 40.4742 65.9999H47.5314C47.7933 65.9999 48.0056 65.7876 48.0056 65.5256V34.4742C48.0056 34.2123 47.7933 34 47.5314 34Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="50" cy="50" r="50" fill="#CE445B" />
                    <path
                      d="M39.8571 65C39.7093 65 39.5614 64.9619 39.4286 64.8851C39.1633 64.7321 39 64.4489 39 64.1429L39.0009 35.857C39.0009 35.551 39.1641 35.2678 39.4294 35.1148C39.6947 34.9617 40.0213 34.9617 40.2866 35.1148L64.783 49.2577C65.0482 49.4107 65.2115 49.6939 65.2115 49.9999C65.2115 50.3059 65.0482 50.5892 64.783 50.7422L40.2857 64.8851C40.1529 64.9619 40.005 65 39.8571 65Z"
                      fill="white"
                    />
                  </svg>
                )}
              </button> */}
            </>
          ) : (
            <iframe
              src={videoUrl}
              title="about intro video"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              className="w-full h-full aspect-video"
            />
          )}
        </div>
      )}
    </section>
  );
}
